export default __webpack_public_path__ + "static/media/logo.bc4a3c73.svg";